export default __webpack_public_path__ + "static/media/ems2.d5ee9c11.png";